import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import FormElement from 'components/FormElement';
import DeviceInfoExtended from 'containers/request/Initial/Steps/Vendor/DeviceInfoExtended';
import DeviceInfoDates from 'containers/request/Initial/Steps/Vendor/DeviceInfoDates';
import DeviceInfoSubmitter from 'containers/request/Initial/Steps/Vendor/DeviceInfoSubmitter';
import { getDeviceTitle } from 'helpers/DeviceTypeHelper';

const DeviceInfo = ({ show, request }) => {
  if (!show) return null;

  const { vendor, modelName, deviceType, bands } = request;

  if (!request.id) return null;

  return (
    <div>
      <Form horizontal>
        <FormElement id="manufTitle" label="Manufacturer" value={vendor} />
        <FormElement
          id="modelName"
          label="Model Name/Number"
          value={modelName}
        />
        <DeviceInfoSubmitter />
        <DeviceInfoDates />
        <FormElement
          id="deviceType"
          label="Device Type"
          value={getDeviceTitle(deviceType)}
        />
        <FormElement
          type="checkboxList"
          id="bands"
          label="Bands"
          value={bands}
          onChange={() => {}}
          list={bands}
          editable={false}
        />
        <DeviceInfoExtended />
      </Form>
    </div>
  );
};

DeviceInfo.propTypes = { show: PropTypes.bool };

DeviceInfo.defaultProps = { show: true };

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(DeviceInfo);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Steps/Laboratory/DeviceInfo.js